<template>
  <div class="human-body-hydration">
    <div
      id="human-body-hydration-counter"
      class="font-weight-bold human-body-hydration__text"
    />
    <svg
      :width="width"
      :height="height"
      viewBox="0 0 74 221"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M36.9715 0C35.8644 0.240668 33.4193 1.12633 32.4951 2.74361L32.0619 2.02161C31.2918 2.64735 29.6937 4.04322 29.4627 4.62082L29.1739 3.61002C28.3075 4.33202 26.5458 6.29587 26.4303 8.37524L26.5747 17.1837C25.8527 17.9057 25.1307 20.2739 28.0187 23.9705L29.8959 28.7358L29.6071 33.7898C26.7191 35.9077 19.6145 40.6055 14.3006 42.4538C10.1611 41.5393 1.30453 45.4862 3.03734 58.6267C3.13361 60.6483 3.29726 64.9226 3.18174 65.8467L2.89294 79.1316C2.17093 86.4961 -1.72789 80.5756 3.32614 115.809V118.986L2.60414 124.185V125.484L6.06975 130.971H8.38017L9.96857 130.683L11.2682 129.816L12.1346 128.805L12.8566 128.083V127.506L10.9794 123.896L10.6906 122.452C11.0275 120.863 11.0083 117.282 8.23576 115.665C8.66897 105.124 13.2898 95.0157 12.279 83.4636C13.3379 79.3242 15.4558 69.3124 15.4558 62.3811C17.7662 68.2534 22.5314 71.334 20.6542 95.8821C16.4666 110.322 10.8386 121.008 14.5894 160.285C13.4342 165.916 6.50296 167.649 14.5894 204.905L13.5786 207.793L13.723 211.403C9.67977 214.435 4.04814 220.211 14.1562 220.211C17.7662 220.211 25.2751 221.511 22.2426 212.414V205.482C22.2426 186.277 29.0295 191.764 24.9863 163.173C29.4916 156.588 34.8536 131.742 36.9715 120.141C39.0894 131.742 44.4515 156.588 48.9568 163.173C44.9136 191.764 51.7004 186.277 51.7004 205.482V212.414C48.668 221.511 56.1768 220.211 59.7868 220.211C69.8949 220.211 64.2633 214.435 60.22 211.403L60.3644 207.793L59.3536 204.905C67.4401 167.649 60.5088 165.916 59.3536 160.285C63.1044 121.008 57.4764 110.322 53.2888 95.8821C51.4116 71.334 56.1768 68.2534 58.4872 62.3811C58.4872 69.3124 60.6051 79.3242 61.664 83.4636C60.6532 95.0157 65.2741 105.124 65.7073 115.665C62.9348 117.282 62.9155 120.863 63.2525 122.452L62.9637 123.896L61.0864 127.506V128.083L61.8084 128.805L62.6749 129.816L63.9745 130.683L65.5629 130.971H67.8733L71.3389 125.484V124.185L70.6169 118.986V115.809C75.6709 80.5756 71.7721 86.4961 71.0501 79.1316L70.7613 65.8467C70.6458 64.9226 70.8094 60.6483 70.9057 58.6267C72.6385 45.4862 63.7819 41.5393 59.6424 42.4538C54.3285 40.6055 47.224 35.9077 44.336 33.7898L44.0471 28.7358L45.9244 23.9705C48.8124 20.2739 48.0904 17.9057 47.3684 17.1837L47.5128 8.37524C47.3972 6.29587 45.6356 4.33202 44.7692 3.61002L44.4804 4.62082C44.2493 4.04322 42.6513 2.64735 41.8811 2.02161L41.4479 2.74361C40.5238 1.12633 38.0786 0.240668 36.9715 0ZM6.79176 123.896L8.23576 123.318L9.67977 126.206L8.23576 126.928L7.65816 126.206L7.36936 125.195L6.79176 123.896ZM67.1513 123.896L65.7073 123.318L64.2633 126.206L65.7073 126.928L66.2849 126.206L66.5737 125.195L67.1513 123.896Z"
        fill="url(#paint0_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="36.9715"
          y1="0"
          x2="36.9715"
          y2="221"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            :offset="offsetGrey + '%'"
            stop-color="#E1E1E3"
          />
          <stop
            :offset="offsetBlue + '%'"
            stop-color="#19ACDB"
          />
          <animate
            attributeName="y1"
            :dur="animateDurationValue"
            from="221"
            to="0"
            repeatCount="1"
          />
        </linearGradient>
      </defs>

    </svg>
  </div>
</template>

<script>
export default {
  name: 'HumanBodyHydration',
  props: {
    value: {
      type: Number,
      default: 1,
      required: true,
      validator: function (val) {
        return val >= 0 && val <= 1
      }
    },
    height: {
      type: String,
      default: '450'
    },
    width: {
      type: String,
      default: '150'
    },
    animationDuration: {
      type: Number,
      default: 2000
    }
  },
  computed: {
    offsetGrey() {
      return this.value === 1 ? 0 : Math.round((1 - this.value) * 100)
    },
    offsetBlue() {
      return this.value === 1 ? 0 : Math.round((1.1 - this.value) * 100)
    },
    viewBoxYEnd() {
      return 221
    },
    animateDurationValue() {
      return this.animationDuration + 'ms'
    }
  },
  mounted() {
    this.animate()
  },
  methods: {
    animate() {
      const obj = document.getElementById('human-body-hydration-counter')
      let startTimestamp = null
      const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp
        const progress = Math.min((timestamp - startTimestamp) / this.animationDuration, 1)
        obj.innerHTML = Math.floor(progress * this.value * 100) + '%'
        if (progress < 1) {
          window.requestAnimationFrame(step)
        }
      }
      window.requestAnimationFrame(step)
    }
  }
}
</script>
